import { TextBase } from '@carboncopyco/ui';

export const NoMetricsMessage = () => {
  return (
    <>
      <TextBase
        color="text-ds-natural-700"
        label="Metrics are not valid for this clone."
      />
    </>
  );
};
